import { cachedDashboardGet } from "./dashboardRequestCache";
import { SalesComparisonPeriod } from "../components/TimelyComparisonCharts/types";

export type SalesTimelyComparisonPeriod = SalesComparisonPeriod;

export interface TimelyComparisonBucketApiItem {
  key: string;
  label: string;
  start_date: string;
  end_date: string;
  value: number;
}

export interface TimelyComparisonSeriesApiItem {
  id: "enquiry" | "quotation" | "order" | "dispatch";
  name: string;
  title: string;
  buckets: TimelyComparisonBucketApiItem[];
  comparison?: {
    current: number;
    previous: number;
    changePct: number | null;
    display: string;
    trend: "up" | "down" | "neutral" | "from_zero";
  };
}

export interface SalesTimelyComparisonChartsResponse {
  period: SalesTimelyComparisonPeriod;
  reference_date: string;
  series: TimelyComparisonSeriesApiItem[];
}

interface ApiResponseEnvelope<T> {
  status: number;
  success: boolean;
  message: string;
  data: T;
}

export const fetchSalesTimelyComparisonCharts = async (
  period: SalesTimelyComparisonPeriod,
): Promise<SalesTimelyComparisonChartsResponse> => {
  const response = await cachedDashboardGet<
    ApiResponseEnvelope<SalesTimelyComparisonChartsResponse>
  >("/dashboard/sales/timely-comparison/charts",
    { period },
  );

  return response.data;
};


